import React, { Suspense, lazy, useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Store from './Store';
import AppShell from './components/layout/AppShell';
import MyRoute from './components/routing/MyRoute';
import SetAuthToken from './components/util/SetAuthToken';
import { loadUser } from './action/Auth';
import { getStatistics } from './action/Statistics';
import Alert from './components/layout/Alert';
import { SocketContext, socket } from './components/context/socket';
import { ThemeProvider } from './components/context/ThemeContext';
import Toaster from '@/components/ui/toaster';
import './App.css';

const Admin = lazy(() => import('./components/Admin'));
const Dashboard = lazy(() => import('./components/Dashboard'));
const Login = lazy(() => import('./components/auth/Login'));
const Main = lazy(() => import('./components/Main'));
const Orders = lazy(() => import('./components/Orders'));
const PrintOrder = lazy(() => import('./components/PrintOrder'));
const Products = lazy(() => import('./components/Products'));
const Register = lazy(() => import('./components/auth/Register'));
const Setting = lazy(() => import('./components/Setting'));

if (localStorage.token) {
  SetAuthToken(localStorage.token);
}

const App = () => {
  useEffect(() => {
    if (localStorage.token && !Store.getState().AuthRedux.user) {
      Store.dispatch(loadUser());
    }
    if (localStorage.user) {
      const user = JSON.parse(localStorage.user);
      if (user && user.partition) Store.dispatch(getStatistics());
    }
  }, []);

  const showContent = () => {
    if (window.location.pathname === '/printorders') {
      return (
        <Suspense fallback={null}>
          <PrintOrder />
        </Suspense>
      );
    }

    return (
      <AppShell>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<MyRoute component={Main} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <MyRoute needShop={true} isRestricted={true} component={Dashboard} />
              }
            />
            <Route
              path="/products"
              element={
                <MyRoute isRestricted={true} needShop={true} component={Products} />
              }
            />
            <Route
              path="/orders"
              element={
                <MyRoute isRestricted={true} needShop={true} component={Orders} />
              }
            />
            <Route
              path="/admin"
              element={<MyRoute isRestricted={true} component={Admin} />}
            />
            <Route path="/setting" element={<MyRoute component={Setting} />} />
          </Routes>
        </Suspense>
      </AppShell>
    );
  };

  return (
    <Provider store={Store}>
      <ThemeProvider>
        <SocketContext.Provider value={socket}>
          <Router>
            <Alert />
            <Toaster />
            {showContent()}
          </Router>
        </SocketContext.Provider>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
